import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';

/**
 * @Author      Jhovanny Fragoso Márquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const serviceName = "traffic-fine-service";
const endPoint = "types";

export const CreateFineType = createAsyncThunk("fineType/createFineType", async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/${endPoint}/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateFineType = createAsyncThunk("fineType/updateFineType", async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/${endPoint}/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
